import { List } from 'immutable';
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import styled from 'styled-components';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getFileMetadata } from 'conversations-internal-schema/resolved-attachment/operators/resolvedAttachmentGetters';
import { getUrl, getHeight, getWidth
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-internal-schema/file-metadata/operators/fileMetadataGetters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { displayName } from 'conversations-internal-schema/file-metadata/operators/displayName';
import InlineImageAttachment from './InlineImageAttachment';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getImageAttachments } from 'conversations-message-history/attachments/operators/imageAttachmentFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_IMAGE_WIDTH = 300;
export const FileAttachmentsWrapper = styled.div.withConfig({
  displayName: "InlineImageAttachments__FileAttachmentsWrapper",
  componentId: "sc-1ri8w2b-0"
})(["cursor:pointer;box-sizing:border-box;width:100%;max-width:", "px;display:block;margin-bottom:16px;margin-top:8px;"], MAX_IMAGE_WIDTH);
class InlineImageAttachments extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      maxWidth: MAX_IMAGE_WIDTH
    };
    this.wrapperRef = /*#__PURE__*/createRef();
  }
  componentDidMount() {
    const current = findDOMNode(this.wrapperRef.current);
    if (current && current.offsetWidth && current.offsetWidth !== this.state.maxWidth) {
      this.setState({
        maxWidth: current.offsetWidth
      });
    }
  }
  render() {
    const {
      fileAttachments
    } = this.props;
    return /*#__PURE__*/_jsx(FileAttachmentsWrapper, {
      "data-test-id": "file-attachments-wrapper",
      ref: this.wrapperRef,
      children: getImageAttachments(fileAttachments).map((fileAttachment, index) => {
        const fileMetadata = getFileMetadata(fileAttachment);
        const name = displayName(fileMetadata);
        const url = getUrl(fileMetadata);
        const width = getWidth(fileMetadata);
        const height = getHeight(fileMetadata);
        return /*#__PURE__*/_jsx(InlineImageAttachment, {
          name: name,
          url: url,
          width: width,
          height: height,
          maxWidth: this.state.maxWidth
        }, `image-${index}`);
      })
    });
  }
}
InlineImageAttachments.displayName = 'InlineImageAttachments';
InlineImageAttachments.propTypes = {
  // @ts-expect-error - TODO: revisit after immutable conversion
  fileAttachments: PropTypes.instanceOf(List)
};
export default InlineImageAttachments;